import requestErrorHandler from './requestErrorHandler';

const logout = (onLogout = () => {
    // This is intentional
}) => {
    return requestErrorHandler(
        fetch(window.environment.backend + 'logout', {
            method: 'POST',
            mode: 'cors',
            credentials: 'include'
        }).then(response => {
            if (!response.ok) {
                throw response;
            }

            onLogout();

            return true;  //we only get here if there is no error
        }), 'POST', () => {
            // This is intentional
        });
};

export default logout;
